type ParamValue = string | number | boolean | null | undefined

export const clearPaymentResponseParams = (url: URL): URL => {
  // 재시도나 결제수단 변경 시 이전 거래의 응답을 새 결제에 전달하지 않는다.
  for (const key of [
    'code',
    'message',
    'error_code',
    'error_msg',
    'imp_success',
    'imp_uid',
    'merchant_uid',
    'payment_id',
    'paymentId',
    'tx_id',
    'txId',
    'billingKey',
    'issue_id',
    'customer_uid',
  ]) {
    url.searchParams.delete(key)
  }
  return url
}

export const setParams = (url: URL, params: Record<string, ParamValue>): URL => {
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      url.searchParams.set(key, String(value))
    }
  })
  return url
}
